import Authenticated from "./Authenticated";

export default Authenticated;
